<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Program RKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input v-model="cari_value" @keyup="cari_data()" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-6">
                                <span class="huruf_input">Tahun RKPD</span>
                                <select @change.prevent="getTahunRKPD()"  class="form-control" v-model="form.rkpd_setup_id">
                                    <option v-for="data in list_RKPD" :key="data.rkpd_setup_id" dat="data.tahun" :value="data.rkpd_setup_id">{{data.rkpd_jenis}} ({{data.tahun}})</option>
                                </select>
                            </div>

                            <div class="col-md-6">
                                <span class="huruf_input">Bidang Urusan</span>
                                <select @click="cari_data()" class="form-control" v-model="form.bidang_urusan_pemerintahan_id">
                                    <!-- <option value="">-- semua urusan --</option> -->
                                    <option v-for="data in list_bidang" :key="data.bidang_urusan_pemerintahan_id" :value="data.bidang_urusan_pemerintahan_id">[{{data.kode}}] {{data.nama_bidang}}</option>
                                </select>
                            </div>
                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table table-bordered" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">
                                    <th class="tabel_center text-center" style="width: 5%">Kode</th>
                                    <th class="tabel_center text-center" style="width: 30%">Nama Program</th>
                                    <th class="tabel_center text-center" style="width: 10%">Target <br> Anggaran RPJMD</th>
                                    <th class="tabel_center text-center" style="width: 10%">Realisasi Anggaran s/d <br> Tahun {{tahun-1}}</th>
                                    <th class="tabel_center text-center" style="width: 10%">Pagu Indikatif <br> (Tahun {{tahun}})</th>
                                    <th class="tabel_center text-center" style="width: 10%">Pagu Program/Forum <br> (Tahun {{tahun}})</th>
                                    <th class="tabel_center text-center" style="width: 10%">Prakiraan Maju <br> (Tahun {{tahun+1}} )</th>


                                    <th class="tabel_center text-center" style="width: 15%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.rkpd_program_id">
                                    <td class="tabel_center text-center">
                                        <!-- cek_program_pembangunan -->
                                        <div v-if="data.cek_program_pembangunan <= 0">
                                            <a @click="selectDataSync(data)" href="javascript:void(0);" title="Tidak Terkoneksi dengan Program Pembangunan RPJMD" data-toggle="modal" data-target="#m_konektifitas_data">
                                                <i class="material-icons" style="color:#e04747">report</i>
                                            </a>
                                        </div>
                                        <div v-if="data.cek_program_pembangunan > 0">
                                            {{index+1}}.
                                        </div>
                                    </td>
                                    <td class="tabel_center" >{{data.program_nama}}</td>
                                    <td class="tabel_center" >{{getAnggaranRPJMD(data)}}</td>
                                    <td class="tabel_center" >{{format_uang(data.anggaran_thn_lalu)}}</td>
                                    <td class="tabel_center" >{{format_uang(data.anggaran_thn_ini)}}</td>
                                    <td class="tabel_center">0</td>
                                    <td class="tabel_center" >{{format_uang(data.anggaran_thn_ini)}}</td>
                                    <td class="tabel_center text-center" >
                                        
                                        <!-- <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Pengaturan Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >settings</i>
                                        </button>
                                        &nbsp; -->
                                        <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="SKPD Pelaksana" data-toggle="modal" data-target="#m_opd_pelaksana">
                                            <i class="material-icons" >account_balance</i>
                                        </button>
                                        &nbsp;
                                        <button @click="removeData(data.rkpd_program_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>

                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RPJMD TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">
                                                    
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered" style="width: 100%">
                                                            <thead>
                                                            <tr class="bg-info kepala_table_f tabel_center">

                                                                <th class="tabel_center text-center" style="width: 10%">Pilih</th>
                                                                <th class="tabel_center text-center" style="width: 10%">Kode</th>
                                                                <th class="tabel_center text-center" style="width: 80%">Program</th>
                                                                <!-- <th class="tabel_center text-center" style="width: 40%">Prioritas</th> -->
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr class="h_isitable" v-for="data in list_program" :key="data.program_pembangunan_id">
                                                                <td class="tabel_center text-center" >
                                                                    <input v-model="form.select_program_pembangunan_id" type="checkbox" :value="{program_pembangunan_id : data.program_pembangunan_id, program_id : data.program_id}" :id="data.program_pembangunan_id" class="filled-in chk-col-blue" :checked="1">
                                                                    <label :for="data.program_pembangunan_id"></label>
                                                                </td>
                                                                <td class="tabel_center" >{{data.program_kode}}</td>
                                                                <td class="tabel_center text-justify">{{data.program_nama}}</td>
                                                            </tr>

                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button  @click="emptyData()" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Realisasi Anggaran s/d Tahun {{tahun-1}}</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="form.realisasi_tahun_lalu" :required="true" type="number" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Pagu Indikatif (Tahun {{tahun}})</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="form.pagu_indikatif" :required="true" type="number" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Prakiraan Maju (Tahun {{tahun+1}})</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <input v-model="form.prakiraan_maju" :required="true" type="number" class="form-control">
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
    

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL OPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_opd_pelaksana" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                            <div class="modal-body">
                                                <button @click="setting_opd = !setting_opd">ATUR ANGGARAN</button>
                                                <hr>
                                                <div class="table-responsive">
                                                    <table class="table table-bordered" style="width: 100%">
                                                        <thead>
                                                        <tr class="bg-info kepala_table_f tabel_center">
                                                            <th class="tabel_center text-center" style="width: 5%">Kode</th>
                                                            <th class="tabel_center text-center" style="width: 55%">OPD Pelaksana</th>
                                                            <th class="tabel_center text-center" style="width: 10%">Anggaran RPJMD</th>
                                                            <th class="tabel_center text-center" style="width: 10%">Anggaran Tahun {{tahun-1}}</th>
                                                            <th class="tabel_center text-center" style="width: 10%">Pagu Tahun {{tahun}}</th>
                                                            <th class="tabel_center text-center" style="width: 10%">Keterangan</th>

                                                       </tr>
                                                        </thead>
                                                        <tbody class="tabel_center" >
                                                        <tr class="h_isitable" v-for="(data, index) in list_OPD" :key="data.rkpd_program_id">
                                                            <td class="tabel_center text-center">{{index+1}}.</td>
                                                            <td class="tabel_center" >{{data.instansi}}</td>
                                                            <td class="tabel_center" >{{getAnggaranRPJMD(data)}}</td>
                                                            <td class="tabel_center text-center">
                                                                <input v-if="setting_opd" type="number" v-model="anggaran_thn_lalu[index]">
                                                                <span v-if="!setting_opd">{{format_uang(data.anggaran_thn_lalu)}}</span>
                                                            </td>
                                                            <td class="tabel_center">
                                                                <input v-if="setting_opd" type="number" v-model="anggaran_thn_ini[index]">
                                                                <span v-if="!setting_opd">{{format_uang(data.anggaran_thn_ini)}}</span>
                                                            </td>
                                                            <td class="tabel_center" >
                                                                <input v-if="setting_opd" type="text" v-model="anggaran_keterangan[index]">
                                                                <span v-if="!setting_opd">{{data.anggaran_keterangan}}</span>
                                                            </td>

                                                        </tr>

                                                        </tbody>
                                                    </table>
                                                </div>

    

                                            </div>
                                            <div class="modal-footer">
                                                <button @click="AddAnggaranOpd" v-if="setting_opd" type="submit" class="btn btn-info waves-effect">RUBAH</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL OPD xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_konektifitas_data" tabindex="-1" role="dialog" data-backdrop ="static">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-orange">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <span style="font-size:120%">ATUR RELASI PROGRAM PEMBANGUNAN (RPJMD)</span> <br>
                                            <i><span style="font-size:80%">{{form.program_nama}}</span></i>
                                            
                                        </div>
                                        <form @submit.prevent="editDataSync()">
                                            <div class="modal-body">

                                                <div class="row clearfix">
                                                    <div class="col-md-3 form-control-label">
                                                        <label for="kode">Program Pembangunan (RPJMD)</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <select class="form-control" v-model="form.program_pembangunan_id">
                                                                <option v-for="data in list_program" :key="data.program_pembangunan_id" :value="data.program_pembangunan_id">[{{data.program_kode}}]. {{data.program_nama}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-warning waves-effect">SINKRONISASI</button>
                                                <button  @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>

<script>

    const ADD_URL = URL_APP+'api/v1/planning_rkpd_program/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';

    const ADD_URL_RKPD = URL_APP+'api/v1/planning_rkpd_awal/';
    const ADD_URL_BIDANG_URUSAN = URL_APP+'api/v1/planning_bidang/';
    const ADD_URL_PROGRAM_PEMBANGUNAN = URL_APP+'api/v1/planning_program_pembangunan/';


    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    rkpd_program_id : '',
                    rkpd_setup_id : '',
                    bidang_urusan_pemerintahan_id : '',
                    select_program_pembangunan_id : [],
                    program_pembangunan_id : '',
                    program_nama : '',
                    program_id : '',
                    realisasi_tahun_lalu : '',
                    pagu_indikatif : '',
                    prakiraan_maju : '',
                },
                anggaran_thn_lalu : [],
                anggaran_thn_ini : [],
                anggaran_keterangan : [],



                setting_opd : false,

                unit_kerja : '',
                unit_kerja_full : '',

                check_data_add : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
                tahun : '',

                list_tahun : [],
                list_RKPD : [],
                list_bidang : [],
                list_program : [],
                list_program_sinc : [],
                list_OPD : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;

            this.form.unit_kerja = get_profile.profile.unit_kerja;


            this.getDataTahun();
            this.getRKPD();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify(this.form)


                }).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                    this.list_program = [];
                    this.getProgram();
                });
            },
            getData: function(){
                
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id,
                      rkpd_setup_id : this.form.rkpd_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                  console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_program = [];
                this.list_OPD = [];
                this.anggaran_thn_lalu = [];
                this.anggaran_thn_ini = [];
                this.keterangan = [];
                this.setting_opd = false;
            },
            selectData : function(data){
                console.log(data)
                this.form = {
                    rkpd_program_id : data.rkpd_program_id,
                    rkpd_setup_id : data.rkpd_setup_id,
                    bidang_urusan_pemerintahan_id : data.bidang_urusan_pemerintahan_id,
                    program_pembangunan_id : data.program_pembangunan_id,
                    program_id : data.program_id,
                    realisasi_tahun_lalu : data.realisasi_tahun_lalu,
                    pagu_indikatif : data.pagu_indikatif,
                    prakiraan_maju : data.prakiraan_maju,
                };

                this.getDataTahun();
                this.getOPD();
            },

            selectDataSync : function(data){
                console.log(data)
                this.form = {
                    rkpd_program_id : data.rkpd_program_id,
                    rkpd_setup_id : data.rkpd_setup_id,
                    bidang_urusan_pemerintahan_id : data.bidang_urusan_pemerintahan_id,
                    program_pembangunan_id : data.program_pembangunan_id,
                    program_id : data.program_id,
                    realisasi_tahun_lalu : data.realisasi_tahun_lalu,
                    pagu_indikatif : data.pagu_indikatif,
                    prakiraan_maju : data.prakiraan_maju,
                    program_nama : data.program_nama,
                };

                this.getDataTahun();
                this.getOPD();
                this.getProgram();
            },
            editDataSync : function(){
                fetch(ADD_URL+'updateDataSync', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.form)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },

        //TAMBAHAN
            getRKPD : function(){
                fetch(ADD_URL_RKPD, {
                        method : 'GET',
                        headers : {
                            "content-type": "application/json",
                            authorization: "kikensbatara " + localStorage.token
                        },
                    }).then((res) => res.json()).then((res_data) => {
                        this.list_RKPD = res_data;
                        this.form.rkpd_setup_id = res_data[0].rkpd_setup_id;
                        this.tahun = parseInt(res_data[0].tahun);
                        this.getBidang();
                        console.log(res_data);
                    })
            },

            getBidang : function(){
                fetch(ADD_URL_BIDANG_URUSAN+'fromRKPD', {
                        method : 'GET',
                        headers : {
                            "content-type": "application/json",
                            authorization: "kikensbatara " + localStorage.token
                        },
                    }).then((res) => res.json()).then((res_data) => {
                        this.list_bidang = res_data;
                        this.form.bidang_urusan_pemerintahan_id = res_data[0].bidang_urusan_pemerintahan_id;
                        this.getData();
                        // console.log(res_data);
                    })
            },

            getProgram : function(){
                fetch(ADD_URL_PROGRAM_PEMBANGUNAN+'fromRKPD', {
                        method : 'POST',
                        headers : {
                            "content-type": "application/json",
                            authorization: "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id
                        })
                    }).then((res) => res.json()).then((res_data) => {

                        this.list_data.forEach(list_data => {
                            for (let i = 0; i < res_data.length; i++) {
                                if (list_data.program_pembangunan_id == res_data[i].program_pembangunan_id) {
                                    res_data.splice(i, 1); 
                                }
                            }
                        });
                        
                        
                        this.list_program = res_data;
                        console.log(res_data);
                    })
            },

            getProgramSync : function(){
                fetch(ADD_URL_PROGRAM_PEMBANGUNAN+'fromRKPD', {
                        method : 'POST',
                        headers : {
                            "content-type": "application/json",
                            authorization: "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id
                        })
                    }).then((res) => res.json()).then((res_data) => {
                        this.list_program = res_data;
                        // console.log(res_data);
                    })
            },

            getTahunRKPD : function(){
                this.tahun = 0;
                fetch(ADD_URL_RKPD+"getOne", {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({rkpd_setup_id : this.form.rkpd_setup_id})
                }).then((res) => res.json()).then((res_data) => {
                    this.tahun = parseInt(res_data[0].tahun);
                    this.cari_data();
                    // console.log(res_data);
                })
            },

            getOPD : function(){
                fetch(ADD_URL+'readOPDPelaksana', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        program_pembangunan_id : this.form.program_pembangunan_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_OPD = res_data;
                  console.log(res_data);
                })
            },
            AddAnggaranOpd : function(){
                fetch(ADD_URL+'AddAnggaranOpd', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify({
                        rkpd_program_id : this.form.rkpd_program_id,
                        rkpd_setup_id : this.form.rkpd_setup_id,
                        bidang_urusan_pemerintahan_id : this.form.bidang_urusan_pemerintahan_id,
                        program_pembangunan_id : this.form.program_pembangunan_id,
                        program_id : this.form.program_id,
                        anggaran_thn_lalu : this.anggaran_thn_lalu,
                        anggaran_thn_ini : this.anggaran_thn_ini,
                        anggaran_keterangan : this.anggaran_keterangan,
                        opd : this.list_OPD,
                    })


                }).then((res_data) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getOPD();
                    this.getData();
                    this.setting_opd = false;
                    this.anggaran_thn_lalu = [];
                    this.anggaran_thn_ini = [];
                    this.anggaran_keterangan = [];
                });
            },

            getAnggaranRPJMD(data){
                var thn_length = (data.rpjmd_ahir - data.rpjmd_awal);
                var thn_awal = data.rpjmd_awal;
                var list_tahun = [thn_awal];
                var thn_saat_ini = this.tahun
                for (let i = 0; i < thn_length; i++) {
                    thn_awal = thn_awal+1
                    list_tahun.push(thn_awal)
                }

                    if (thn_saat_ini == list_tahun[0]) {
                        return this.format_uang(data.tahun_1);
                    } 
                    else if (thn_saat_ini == list_tahun[1]) {
                        return this.format_uang(data.tahun_2);
                    }
                    else if (thn_saat_ini == list_tahun[2]) {
                        return this.format_uang(data.tahun_3);
                    }
                    else if (thn_saat_ini == list_tahun[3]) {
                        return this.format_uang(data.tahun_4);
                    }
                    else if (thn_saat_ini == list_tahun[4]) {
                        return this.format_uang(data.tahun_5);
                    }
                    else if (thn_saat_ini == list_tahun[5]) {
                        return this.format_uang(data.tahun_6);
                    }

            },



        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;
                this.getData();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            btn_check_data_add : function(){
                // this.getDataTahun();
                if (this.form.tahun != '') {
                    this.check_data_add = true;
                }else{
                    this.check_data_add = false;
                }

                this.getProgram();
            },
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
                // this.getProgram()
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    // console.log(res_data);
                    this.form.tahun = this.getTgl().tahun
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : parseInt(),
                }
            },
            format_uang : function(angka, prefix){
                if (angka == null || angka == '' || angka == undefined) {
                    return angka;
                } else {
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                }
            },


        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>